import React from "react";
import { Link } from "react-router-dom";
import '../assets/css/Footer.css';


function Footer(props) {
    return (
        <footer className={`main-footer stickyBar ${props?.menuActive ? 'fullStickyBar' : ''}`}>
            <div className='container footerContent'>
                <div className="footerLeft">
                    <p>© {new Date().getFullYear()} Ivycorn. All rights reserved.</p>
                </div>
                <ul>
                    <li><Link>Terms of Service</Link></li>
                    <li><Link>Privacy Policy</Link></li>
                    <li><Link>Cookie Policy</Link></li>
                </ul>
            </div>
        </footer>
    );

}
export default Footer;